import { merge } from 'lodash-es';

const getInitialState = () => ({
  tiers: {
    tier0: false,
    tier1: false,
    tier2: false,
    tier3: false
  }
});

export default {
  namespaced: true,
  state: getInitialState,
  getters: {
    tiers: _state => _state.tiers
  },
  mutations: {
    FETCH_REPLACEMENT_SUCCESS(state, payload) {
      state.tiers = merge({}, state.tiers, payload);
    },
    FETCH_ENCRYPTION_ERROR() {
      return null;
    },
    FLUSH_STATE(state) {
      Object.assign(state, getInitialState());
    },
  },
  actions: {
    FETCH_REPLACEMENT({ commit }) {
      return this.$api.get('/api/v2/cses/automatic-disk-replacement/settings/')
        .then(({ data }) => {
          commit('FETCH_REPLACEMENT_SUCCESS', data);
        })
        .catch((error) => {
          commit('FETCH_REPLACEMENT_ERROR', error?.data);
          throw error;
        });
    },
    SAVE_REPLACEMENT({ commit }, tiers) {
      return this.$api.put('/api/v2/cses/automatic-disk-replacement/settings/', tiers)
        .then(({ data }) => {
          commit('FETCH_REPLACEMENT_SUCCESS', data);
        })
        .catch((error) => {
          commit('FETCH_REPLACEMENT_ERROR', error?.data);
          throw error;
        });
    }
  }
};
